function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mofoColors = {
  white: "#ffffff",
  fieldBackground: "#f5f7fa",
  background: "#eaecef",
  almostWhite: "#f7f8fa",
  divider: "#e2e2e2",
  disabled: "#d9d9d9",
  fieldBorder: "#DEDEDE",
  smurfette: "#e0f6ff",
  papaSmurf: "#1cb6f4",
  mystique: "#1392c5",
  neonGreen: "#cdff6b",
  mofoGreen: "#77b204",
  greenLantern: "#48a90f",
  bubbly: "#fff2d4",
  liquidGold: "#d6a871",
  charlie: "#fca403",
  sunlit: "#fca403",
  clockwork: "#ff6d21",
  pinky: "#ff62a5",
  deal: "#d51c5c",
  redRedWine: "#9a0945",
  dorianGray: "#626468",
  darkMofo: "#232627",
  vader: "#131314",
  black: "#000000",
  charcoal: "#212529",
  midGray: "#707070",
  charcoalTeal: "#122122"
};
var themeColors = _objectSpread({
  brand: mofoColors.mofoGreen,
  primary: mofoColors.greenLantern,
  secondary: mofoColors.vader,
  mofoBrand: mofoColors.mofoGreen,
  mofoPrimary: mofoColors.greenLantern,
  mofoSecondary: mofoColors.vader,
  text: {
    heading: mofoColors.charcoal,
    normal: mofoColors.midGray,
    button: mofoColors.vader
  }
}, mofoColors);
var breakpointValues = [0, 768, 980, 1024, 1200];
var fontSizes = [12, 14, 16, 18, 20, 24, 26, 28, 30, 32, 36, 40, 42, 48, 64, 96];
export var baseTheme = {
  colors: _objectSpread({}, themeColors),
  spaces: [0, 10, 16, 20, 30, 40, 60, 100],
  breakpoints: breakpointValues.map(function (value) {
    return "".concat(value, "px");
  }),
  mq: {
    min: {
      tablet: "(min-width: ".concat(breakpointValues[1] + 1, "px)"),
      desktop: "(min-width: ".concat(breakpointValues[2] + 1, "px)")
    },
    max: {
      mobile: "(max-width: ".concat(breakpointValues[1] - 1, "px)"),
      tablet: "(max-width: ".concat(breakpointValues[2] - 1, "px)"),
      laptop: "(max-width: ".concat(breakpointValues[3] - 1, "px)")
    }
  },
  fonts: {
    heading: "\"GT Walsheim\", sans-serif",
    normal: "\"DM Sans\", sans-serif"
  },
  fontSizes: fontSizes,
  letterSpacings: {
    tight: "-0.025em",
    normal: "0em",
    wide: "0.025em"
  },
  lineHeights: {
    none: "1",
    "short": "1.25",
    normal: "1.5",
    tall: "1.625"
  }
};
export var defaultToolkitTheme = _objectSpread({}, baseTheme);